import { environment } from "./environment.base";
export { environment };

environment.name = 'app';
environment.parentUrl =  'https://app.strayos.com';
environment.baseUrl = 'https://appdashboards.strayos.com';
environment.apiUrl = 'https://appdb.strayos.com';